<template>
  <div v-on:click="gotoContractDetail" v-bind:class="['sign-contract-card' ,firstCard]">
    <div class="info">
      <img :src="logo" />
      <div>
        <div class="title">{{status | ContractStatusFormat}}</div>
        <div class="detail" v-html="content"></div>
      </div>
	  <!-- {{num}} -->
      <div :style="'font-size:'+num>99?26:num>9?30:40+'px'" class="sum">{{num}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: "待我签"
    },
    content: {
      type: String,
      default: "内容"
    },
    num: {
      default: 0
    }
  },
  data() {
    return {
      firstCard: "sign-contract-card-first"
    };
  },
  created() {
    if (this.index > 1) this.firstCard = "";
    let that = this;
  },
  methods: {
    gotoContractDetail: function() {
      this.$router.push("/document/" + this.status);
    }
  }
};
</script>

<style lang="scss">
.sign-contract-card-first {
  margin-left: 0px !important;
}
.sign-contract-card {
  width: 24.2%;
  height: 94px;
  display: inline-block;
  margin-left: 1%;
  text-align: left;
  cursor: pointer;
  background:rgba(255,255,255,1);
  box-shadow:0px -2px 7px 0px rgba(164,161,161,0.23);
  border-radius:5px;
}
.sign-contract-card:hover{
  /*background: rgba(27, 133, 85, 0.15);*/
  /*border:1px solid rgba(49,202,132,1);*/
  box-shadow:0px -2px 7px 0px rgba(164,161,161,0.23);
  border-radius:5px;
  border:1px solid rgba(49,202,132,1);
}
.sign-contract-card .info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  height: 100%;
}
.sign-contract-card .info .title {
  font-weight: 600;
  color: rgba(27, 133, 85, 1);
  margin-bottom: 3px;
  font-size: 16px;
}
.sign-contract-card .info .detail {
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  margin-top: 3px;
}
.sign-contract-card .info img {
  height: 35px;
  width: 35px;
}
.sign-contract-card .sum {
  font-size: 40px;
  font-family: ArialMT;
  color: rgba(68, 68, 68, 1);
}
</style>